import Richmond1 from '../Richmond/Richmond (1).webp'
import Richmond2 from '../Richmond/Richmond (2).webp'
import Richmond3 from '../Richmond/Richmond (3).webp'
import Richmond4 from '../Richmond/Richmond (4).webp'
import Richmond5 from '../Richmond/Richmond (5).webp'
import Richmond6 from '../Richmond/Richmond (6).webp'
import Richmond7 from '../Richmond/Richmond (7).webp'
import Richmond8 from '../Richmond/Richmond (8).webp'
import Richmond9 from '../Richmond/Richmond (9).webp'
import Richmond10 from '../Richmond/Richmond (10).webp'
import Richmond11 from '../Richmond/Richmond (11).webp'
import Richmond12 from '../Richmond/Richmond (12).webp'
import Richmond13 from '../Richmond/Richmond (13).webp'
import Richmond14 from '../Richmond/Richmond (14).webp'
import Richmond15 from '../Richmond/Richmond (15).webp'
import Richmond16 from '../Richmond/Richmond (16).webp'
import Richmond17 from '../Richmond/Richmond (17).webp'
import Richmond18 from '../Richmond/Richmond (18).webp'
import Richmond19 from '../Richmond/Richmond (19).webp'
import Richmond20 from '../Richmond/Richmond (20).webp'
import Richmond21 from '../Richmond/Richmond (21).webp'

const Richmondimages =[
Richmond1,Richmond2,Richmond3,Richmond4,Richmond5,Richmond6,Richmond7,Richmond8,Richmond9,Richmond10,Richmond11,Richmond12,Richmond13,Richmond14,Richmond15,Richmond16,Richmond17,Richmond18,Richmond19,Richmond20,Richmond21
]

export default Richmondimages;